module.exports = __webpack_public_path__ + "static/measure-what-matters-fe8cabd2563289429a0d726586531049.jpg";